/* ==========================================================================
   Kleos — Cabecera (assets/iurop-header.js)
   --------------------------------------------------------------------------
   · Hace sticky el wrapper .shopify-section de la cabecera ([data-sticky])
     y añade .is-stuck (sombra) al hacer scroll.
   · Abre/cierra el menú móvil fullscreen #IuropMobileMenu
     ([data-menu-open] / [data-menu-close], Escape, foco devuelto al abrir/cerrar).
     Al pulsar un enlace, el buscador ([data-search-toggle]) o el carrito
     ([data-cart-toggle]) dentro del panel, el menú se cierra solo.
   · Mantiene el contador del carrito [data-cart-count] al día escuchando
     'cart:updated' (contrato de iurop-cart.js / iurop-product-card.js).
   Se carga una vez (defer) desde sections/header.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropHeaderInit) return;
  window.__iuropHeaderInit = true;

  var header = document.querySelector('[data-iurop-header]');
  var panel = document.getElementById('IuropMobileMenu');
  var lastFocus = null;
  var closeTimer = null;
  var lockScrollY = 0;

  /* ---------- Sticky ---------- */
  if (header && header.hasAttribute('data-sticky')) {
    var section = header.closest('.shopify-section');
    if (section) section.classList.add('iurop-header-sticky');

    var onScroll = function () {
      header.classList.toggle('is-stuck', (window.scrollY || 0) > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menú móvil ---------- */
  function menuIsOpen() {
    return panel && !panel.hidden;
  }

  function openMenu() {
    if (!panel || menuIsOpen()) return;
    if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
    lastFocus = document.activeElement;
    panel.hidden = false;
    // doble rAF para que la transición de opacidad se dispare tras el reflow
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
    });
    // Bloqueo de scroll iOS-safe: el scroller es <html>. Guardamos la posición,
    // ponemos overflow:hidden en html y body:fixed con top negativo (el CSS lo
    // hace fijo); al cerrar restauramos el scroll. Sin esto la página de fondo
    // sigue desplazándose bajo el menú (queja móvil).
    lockScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('iurop-lock');
    document.body.classList.add('iurop-lock');
    document.body.style.top = -lockScrollY + 'px';
    toggleExpanded(true);
    var closeBtn = panel.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu(restoreFocus) {
    if (!menuIsOpen()) return;
    panel.classList.remove('is-open');
    // Liberar el bloqueo de scroll y RESTAURAR la posición previa (el body
    // estaba fixed con top negativo → sin restaurar, la página salta arriba).
    document.documentElement.classList.remove('iurop-lock');
    document.body.classList.remove('iurop-lock');
    document.body.style.top = '';
    window.scrollTo(0, lockScrollY);
    toggleExpanded(false);
    closeTimer = window.setTimeout(function () {
      panel.hidden = true;
      closeTimer = null;
    }, 220);
    if (restoreFocus !== false && lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function toggleExpanded(open) {
    var openers = document.querySelectorAll('[data-menu-open]');
    for (var i = 0; i < openers.length; i++) {
      openers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) {
      e.preventDefault();
      openMenu();
      return;
    }
    if (t.closest('[data-menu-close]')) {
      e.preventDefault();
      closeMenu();
      return;
    }
    if (menuIsOpen() && panel.contains(t)) {
      // Buscador o carrito desde dentro del menú: cerramos el panel y dejamos
      // que iurop-search.js / iurop-cart.js gestionen su apertura.
      if (t.closest('[data-search-toggle]') || t.closest('[data-cart-toggle]')) {
        closeMenu(false);
        return;
      }
      // Navegar desde el menú también lo cierra (por si el destino es un ancla).
      var link = t.closest('a[href]');
      if (link && !link.closest('[data-iurop-quick-add]')) closeMenu(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuIsOpen()) closeMenu();
  });

  // Si pasamos a desktop con el menú abierto, lo cerramos.
  var mq = window.matchMedia('(min-width: 990px)');
  var onMq = function (ev) { if (ev.matches) closeMenu(false); };
  if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onMq);
  else if (typeof mq.addListener === 'function') mq.addListener(onMq);

  /* ---------- Contador del carrito ---------- */
  function setCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      if (cart.item_count > 0) badges[i].removeAttribute('hidden');
      else badges[i].setAttribute('hidden', '');
    }
  }

  document.addEventListener('cart:updated', function (e) {
    setCartCount(e.detail && e.detail.cart);
  });
  document.addEventListener('cart:added', function (e) {
    if (e.detail && e.detail.cart) setCartCount(e.detail.cart);
    // Quick-add desde el carrusel del menú móvil: el drawer del carrito abre
    // POR DEBAJO del menú (menú z200 > drawer). Cerramos el menú (sin devolver
    // el foco: el drawer lo toma) en vez de subir el z del drawer por encima
    // del lightbox (300).
    if (menuIsOpen()) closeMenu(false);
  });
})();
